
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class StatusButton extends Vue {
  @Prop({ type: String, required: true }) private readonly color!: string;
  @Prop(String) private readonly avatarColor!: string;
  @Prop({ type: Boolean, required: true }) private readonly active!: boolean;
  @Prop({ type: String, required: true }) private readonly text!: string;
  @Prop({ type: Number, required: true }) private readonly count!: number;
  private winWidth: number = window.innerWidth;
}
